import React from "react";
import styles from '../styles/News.module.css';

const News = () => {

    const pub = process.env.PUBLIC_URL;

    return (
        <div id={styles[`news`]} className={`${styles.fpSection} ${styles.fpTable}`}>  
            <div className={styles.fpTableCell}>
                <div className={`${styles.basicIn}`}>
                    <div className={styles.left}>
                        <img src={`${pub}/main/6p/001.png`} alt="SIDE" />
                    </div>
                    <div className={styles.right}>
                        <div className={styles.mainArea}>
                            <span className={styles.mainContent}>MEDIA</span>
                            <h2 className={styles.mainTitle}>보도자료</h2>
                        </div>
                        <span className={styles.backTitle}>SOCIAL MEDIA</span>
                        <div className={styles.content}>
                            <div className={styles.title}>
                                <p>성장을 함께하는 오퍼그룹의 새로운 소식</p>
                            </div>
                            <div className={styles.newsList}>
                                <a href="#!" target="_blank" rel="noopener noreferrer">
                                    <img src={`${pub}/main/6p/임시뉴스타이틀.png`} alt="임시뉴스타이틀"/>
                                </a>
                            </div>
                            <div className={styles.divider}></div>
                            <div className={styles.randomList}>
                                <div className={styles.imgContainer}>
                                    <a href="https://blog.naver.com/mj_9415/223502466163" target="_blank" rel="noopener noreferrer">
                                        <img className={styles.linkImg} src={`${pub}/main/6p/002.png`} alt="링크" />
                                    </a>
                                </div>
                                <div className={styles.imgContainer}>
                                    <a href="https://blog.naver.com/dodo8305/223610267459" target="_blank" rel="noopener noreferrer">
                                        <img className={styles.linkImg} src={`${pub}/main/6p/003.png`} alt="링크" />
                                    </a>
                                </div>
                                <div className={styles.imgContainer}>
                                    <a href="https://blog.naver.com/best_binkyung/223615013449" target="_blank" rel="noopener noreferrer">
                                        <img className={styles.linkImg} src={`${pub}/main/6p/004.png`} alt="링크" />
                                    </a>
                                </div>
                                <div className={styles.imgContainer}>
                                    <a href="https://www.instagram.com/p/DCDgWoNSjxZ/?utm_source=ig_web_copy_link" target="_blank" rel="noopener noreferrer">
                                        <img className={styles.linkImg} src={`${pub}/main/6p/005.png`} alt="링크" />
                                    </a>
                                </div>
                                <div className={styles.imgContainer}>
                                    <a href="https://youtube.com/@chwaglewagle?si=huH48FpVOqy5LApv" target="_blank" rel="noopener noreferrer">
                                        <img className={styles.linkImg} src={`${pub}/main/6p/006.png`} alt="링크" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.tBox}>
                        <p>BUSINESS SOLUTION COMPANY</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default News;